import { useState } from 'react';
import { Controller, Path, UseFormReturn } from 'react-hook-form';
import cn from 'classnames';
import { PickByType } from 'types/pickByType';
import styles from './Textarea.module.css';

type Props<T extends object> = Omit<
  JSX.IntrinsicElements['textarea'],
  'form' | 'name'
> & {
  form: UseFormReturn<T>;
  name: Path<PickByType<T, string | number>>;
};

const Textarea = <T extends object>({
  form,
  className,
  placeholder,
  name,
  ...restOfProps
}: Props<T>): JSX.Element => {
  const [isFocused, setIsFocused] = useState(false);

  const onInputFocus = (): void => {
    setIsFocused(true);
  };

  const onInputBlur = (): void => {
    setIsFocused(false);
  };

  // TODO Need to figure out how to check the presence of the controller field in runtime and afterward remove "any" type
  return (
    <Controller<any>
      control={form.control}
      name={name}
      render={({ field: { value, onChange }, fieldState: { error } }) => {
        const onChangeInput = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
          onChange(event.target.value);
        };

        const shouldDisplayError = !!error && !isFocused;

        return (
          <div className={styles.textareaWrapper}>
            <textarea
              className={cn(
                styles.textarea,
                className,
                shouldDisplayError && styles.error,
              )}
              value={String(value ?? '')}
              placeholder={placeholder}
              onChange={onChangeInput}
              onFocus={onInputFocus}
              onBlur={onInputBlur}
              {...restOfProps}
            ></textarea>
            {shouldDisplayError && (
              <span className={styles.errorLabel}>{error?.message}</span>
            )}
          </div>
        );
      }}
    />
  );
};

export default Textarea;
